module.exports = __webpack_public_path__ + "img/olfato_1.2374d05e.png";